import script from "./MonthlyIncomeWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyIncomeWidget.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyIncomeWidget.vue?vue&type=style&index=0&id=ce6f55e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce6f55e4"]])

export default __exports__